import { NgModule } from '@angular/core';

// MATERIAL IMPORTS
import { MAT_DATE_LOCALE } from '@angular/material/core';
import { DragDropModule } from '@angular/cdk/drag-drop';
import { ClipboardModule } from '@angular/cdk/clipboard';

// SERVICES
import { DateexplorerPipe } from './other/dateexplorer.pipe';
import { SafeHtmlPipe } from './other/safehtml.pipe';
import { LatinizeService } from './other/latinize';
import { LatinizePipe } from './other/latinize/latinize.pipe';
import { SafePipe } from './other/safe/safe.pipe';

// OTHER MODULES
import { DialogComponent } from './other/dialog/dialog.component';
import { CommonModule } from '@angular/common';
import { CoreModule } from '../core/core.module';
import { PipesModule } from './pipes/pipes.module';
import { AngularResizeEventModule } from 'angular-resize-event';
import { DialogDynSig } from '../finish/types/dynsig/dialog/sign';
import { DialogDynSigPro } from '../finish-pro/components/signature/dialog/signpro';
import { DialogCsvComponent } from './dialog/dialog-csv/dialog-csv.component';
import { MaterialModule } from './material.module';
import { LoadSigTypeDirective } from '../finish/types/dynsig/load-sig-type.directive';
import { DialogConfirmComponent } from './dialog/dialog-confirm/dialog-confirm.component';
import { DialogSignerComponent } from './dialog/dialog-signer/dialog-signer.component';
import { DialogCustomMessageComponent } from './dialog/signaturit/dialog-custom-message/dialog-custom-message.component';
import { GeneralInfoComponent } from './components/circuits-info/general-info/general-info.component';
import { DocumentsInfoComponent } from './components/circuits-info/documents-info/documents-info.component';
import { PdfViewerModule } from 'ng2-pdf-viewer';

// SIGNATURIT COMPONENTS
import { TableComponent } from './components/signaturit/table/table.component';
import { ButtonComponent } from './components/signaturit/button/button.component';
import { InputComponent } from './components/signaturit/input/input.component';
import { TagComponent } from './components/signaturit/tag/tag.component';
import { KebabMenuComponent } from './components/signaturit/kebab-menu/kebab-menu.component';
import { NotificationComponent } from './components/signaturit/notification/notification.component';
import { ListDragdropComponent } from './components/signaturit/list-dragdrop/list-dragdrop.component';
import { SelectComponent } from './components/signaturit/select/select.component';
import { AutocompleteComponent } from './components/signaturit/autocomplete/autocomplete.component';
import { TextAreaComponent } from './components/signaturit/text-area/text-area.component';
import { TableFiltersComponent } from './components/signaturit/table-filters/table-filters.component';
import { DatepickerComponent } from './components/signaturit/datepicker/datepicker.component';
import { MatDialogModule } from '@angular/material/dialog';
import { CreateProComponent } from '../base/circuits/create-pro/create-pro.component';
import { WidgetSettingsProComponent } from '../base/circuits/create-pro/components/widget-settings-pro/widget-settings-pro.component';
import { ToggleComponent } from './components/signaturit/toggle/toggle.component';
import { ReactiveInputComponent } from './components/signaturit/reactive-input/reactive-input.component';
import { ReactiveInputPhoneComponent } from './components/signaturit/reactive-input-phone/reactive-input-phone.component';
import { ColorPickerComponent } from './components/signaturit/color-picker/color-picker.component';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { HighlightModule } from 'ngx-highlightjs';
import { DialogDeclineSignComponent } from './dialog/signaturit/dialog-decline-sign/dialog-decline-sign.component';
import { DialogCustomFieldsComponent } from '../shared/dialog/signaturit/dialog-custom-fields/dialog-custom-fields.component'
import { SearchAutocompleteComponent } from './components/signaturit/search-autocomplete/search-autocomplete.component';
import { IvLoadingComponent } from './components/iv-loading/iv-loading.component';
import { IvLoginComponent } from './components/iv-login/iv-login.component';
import { IvSelectComponent } from './components/iv-select/iv-select.component';
import { IvMessageComponent } from './components/iv-message/iv-message.component';
import { IvFormComponent } from './components/iv-form/iv-form.component';
import { IvSelectMenuComponent } from './components/iv-select-menu/iv-select-menu.component';
import { IvPadComponent } from './components/iv-pad/iv-pad.component';
import { SignatureCanvasComponent } from './components/iv-pad/signature-canvas/signature-canvas.component';
import { DialogCompanyRelationsComponent } from '../base/company-relations/dialog/dialog-company-relations.component';
import { DomChangeDirective } from './directives/dom-change.directive';
import { SigorgaModalComponent } from './modals/sigorga-modal/sigorga-modal.component';
import { DialogInternalMessage } from '../finish/dialog/internal-message/dialog-internal-message.component';

@NgModule({
  declarations: [
    LatinizePipe,
    SafePipe,
    DateexplorerPipe,
    SafeHtmlPipe,
    DialogDynSig,
    DialogDynSigPro,
    DialogComponent,
    DialogCsvComponent,
    LoadSigTypeDirective,
    TableComponent,
    ButtonComponent,
    InputComponent,
    TagComponent,
    KebabMenuComponent,
    NotificationComponent,
    ListDragdropComponent,
    SelectComponent,
    AutocompleteComponent,
    TextAreaComponent,
    DialogConfirmComponent,
    DialogCompanyRelationsComponent,
    DialogSignerComponent,
    DialogDeclineSignComponent,
    ToggleComponent,
    DialogCustomMessageComponent,
    GeneralInfoComponent,
    DocumentsInfoComponent,
    TableFiltersComponent,
    DatepickerComponent,
    CreateProComponent,
    WidgetSettingsProComponent,
    ReactiveInputComponent,
    ReactiveInputPhoneComponent,
    ColorPickerComponent,
    DialogCustomFieldsComponent,
    SearchAutocompleteComponent,
    DialogCustomFieldsComponent,
    IvLoadingComponent,
    IvLoginComponent,
    IvSelectComponent,
    IvMessageComponent,
    IvFormComponent,
    IvSelectMenuComponent,
    IvPadComponent,
    SignatureCanvasComponent,
    DomChangeDirective,
    DialogInternalMessage,
    SigorgaModalComponent
  ],
  imports: [
    CoreModule,
    CommonModule,
    DragDropModule,
    PipesModule,
    AngularResizeEventModule,
    ClipboardModule,
    MaterialModule,
    MatProgressSpinnerModule,
    PdfViewerModule,
    MatDialogModule,
    HighlightModule
  ],
  exports: [
    CoreModule,
    LatinizePipe,
    SafePipe,
    DateexplorerPipe,
    SafeHtmlPipe,
    DialogComponent,
    CommonModule,
    DragDropModule,
    PipesModule,
    AngularResizeEventModule,
    ClipboardModule,
    MaterialModule,
    TableComponent,
    ButtonComponent,
    InputComponent,
    TagComponent,
    KebabMenuComponent,
    SelectComponent,
    NotificationComponent,
    AutocompleteComponent,
    TextAreaComponent,
    ListDragdropComponent,
    DialogSignerComponent,
    DialogDeclineSignComponent,
    DialogCustomMessageComponent,
    ToggleComponent,
    GeneralInfoComponent,
    DocumentsInfoComponent,
    TableFiltersComponent,
    DatepickerComponent,
    CreateProComponent,
    WidgetSettingsProComponent,
    ReactiveInputComponent,
    ColorPickerComponent,
    ReactiveInputPhoneComponent,
    SearchAutocompleteComponent,
    IvLoadingComponent,
    IvLoginComponent,
    IvSelectComponent,
    IvMessageComponent,
    IvFormComponent,
    IvSelectMenuComponent,
    IvPadComponent,
    DomChangeDirective,
    SigorgaModalComponent
  ],
  providers: [
    { provide: MAT_DATE_LOCALE, useValue: 'es-ES' },
    LatinizeService
  ]
})
export class SharedModule { }
